import React from "react";
import Typography from "@material-ui/core/Typography";
import { Breadcrumbs as MuiBreadcrumbs, Link, Box } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { IBreadcrumbsProps } from "./types";

export const Breadcrumbs = ({ breadcrumbs }: IBreadcrumbsProps) => {
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }

  return (
    <Box mb={4}>
      <MuiBreadcrumbs>
        {breadcrumbs.map((breadcrumb) => {
          if (breadcrumb.link) {
            return (
              <Link
                color="inherit"
                to={breadcrumb.link}
                key={breadcrumb.label}
                component={RouterLink}
              >
                <Typography color="textPrimary" variant="h6">
                  {breadcrumb.label}
                </Typography>
              </Link>
            );
          }
          return (
            <Typography key={breadcrumb.label} color="textPrimary" variant="h6">
              {breadcrumb.label}
            </Typography>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};
